import type { ComponentPropsWithRef } from "react";

export const PinOutlineIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      data-name="Path 246189"
      d="M14.707 2.293a1 1 0 1 0-1.414 1.414l.793.793-5.3 5.3a5.638 5.638 0 0 0-5.444 1.444 2 2 0 0 0 0 2.828l2.586 2.586-3.635 3.635a1 1 0 1 0 1.414 1.414l3.636-3.636 2.586 2.585a2 2 0 0 0 2.828 0 5.638 5.638 0 0 0 1.443-5.443l5.3-5.3.793.793a1 1 0 1 0 1.414-1.414zm-3.364 16.95-6.586-6.586a3.66 3.66 0 0 1 5.172 0l1.414 1.414a3.661 3.661 0 0 1 0 5.172zm1.941-5.943a5.44 5.44 0 0 0-.527-.645l-1.414-1.414a5.522 5.522 0 0 0-.645-.527l4.8-4.8L18.086 8.5z"
      transform="translate(-2 -2)"
      fill="currentColor"
    />
  </svg>
);
